import {
    APIFailureAction,
    APIRequestAction,
    APISuccessAction,
} from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

///////////////////////////////////////////////////////////////////
// Phone verification load

export const PHONE_VERIFICATION_FETCH_TRIGGER = 'PHONE_VERIFICATION_FETCH_TRIGGER';
export interface PhoneVerificationFetchTriggerAction {
    readonly type: typeof PHONE_VERIFICATION_FETCH_TRIGGER;
    readonly userId: number;
}
export const PHONE_VERIFICATION_FETCH_REQUEST = 'PHONE_VERIFICATION_FETCH_REQUEST';
export interface PhoneVerificationFetchRequestAction extends APIRequestAction {
    readonly type: typeof PHONE_VERIFICATION_FETCH_REQUEST;
    readonly userId: number;
}
export interface PhoneVerificationFetchNormalizedResponse extends NormalizedResponse {
    readonly result: { alreadyVerified: boolean; };
}
export const PHONE_VERIFICATION_FETCH_SUCCESS = 'PHONE_VERIFICATION_FETCH_SUCCESS';
export interface PhoneVerificationFetchSuccessAction extends APISuccessAction<PhoneVerificationFetchNormalizedResponse> {
    readonly type: typeof PHONE_VERIFICATION_FETCH_SUCCESS;
    readonly userId: number;
}
export const PHONE_VERIFICATION_FETCH_FAILURE = 'PHONE_VERIFICATION_FETCH_FAILURE';
export interface PhoneVerificationFetchFailureAction extends APIFailureAction {
    readonly type: typeof PHONE_VERIFICATION_FETCH_FAILURE;
    readonly userId: number;
}

export const phoneVerificationFetchTrigger =
    (userId: number): PhoneVerificationFetchTriggerAction => ({
        type: PHONE_VERIFICATION_FETCH_TRIGGER, userId,
    });
export const phoneVerificationFetchApi = {
    request: (userId: number): PhoneVerificationFetchRequestAction => ({
        type: PHONE_VERIFICATION_FETCH_REQUEST, userId,
    }),
    success: (userId: number, response: PhoneVerificationFetchNormalizedResponse): PhoneVerificationFetchSuccessAction => ({
        type: PHONE_VERIFICATION_FETCH_SUCCESS, userId, response,
    }),
    failure: (userId: number, error: any): PhoneVerificationFetchFailureAction => ({
        type: PHONE_VERIFICATION_FETCH_FAILURE, userId, error,
    }),
};
